export class PlanningEspace {
    idplanning: string;
    datedebut: Date;
    datefin: Date;
    reserve: boolean;
    idutilisateur: number;
    idcours: number;
    depasse: boolean;
}


// WEBPACK FOOTER //
// /home/codevi/Documents/PROJET/resa-parklife/front/src/app/model/planningEspace.model.ts